import React, { useEffect, useState } from "react";
import { showError, showSuccess } from "../../utils/toastUtils";
import addressAPI from "../../api/addressApi";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import useNumericInput from "../../hooks/useNumericInput";

function Addresses() {
  useAlphabeticInput();
  useNumericInput();

  const [isOpen, setIsOpen] = useState(false);
  const toggleAccordion = () => setIsOpen(!isOpen);
  const [addresses, setAddresses] = useState([]);

  const INITAL_FORM_DATA = {
    firstName: "",
    lastName: "",
    addressType: "home",
    addressLine1: "",
    addressLine2: "",
    pinCode: "",
    district: "",
    state: "",
    country: "",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [formData, setFormData] = useState(INITAL_FORM_DATA);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchAddress();
  }, []);

  const fetchAddress = async () => {
    try {
      const res = await addressAPI.getAllAddress();
      if (res.code === 200) {
        setAddresses(res.data);
      }
    } catch (err) {}
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.firstName) {
      newErrors.firstName = "Please Enter First Name";
    }

    if (!formData.addressType) {
      newErrors.addressType = "Please Enter Address Type";
    }

    if (!formData.addressLine1) {
      newErrors.addressLine1 = "Please Enter Address";
    }

    if (!formData.pinCode) {
      newErrors.pinCode = "Please Enter PinCode";
    } else if (!(formData.pinCode !== 6)) {
      newErrors.pinCode = "PinCode must be of 6 digits";
    }

    if (!formData.district) {
      newErrors.district = "Please Enter District";
    }

    if (!formData.state) {
      newErrors.state = "Please Enter State";
    }

    if (!formData.country) {
      newErrors.country = "Please Enter Country";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) {
      return;
    }
    try {
      const res = await addressAPI.addNewAddress(formData);
      if (res.code === 200) {
        showSuccess(res.message);

        setTimeout(function () {
          setIsOpen(false);
          fetchAddress();
        }, 1000);

        setFormData(INITAL_FORM_DATA);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  const deleteAddress = async (id) => {
    try {
      const res = await addressAPI.deleteAddress(id);
      if (res.code === 200) {
        fetchAddress();
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <>
      <div className="my-acount-content account-address mb-5">
        <h6 className="title-account">My addresses ({addresses.length})</h6>
        <div className="widget-inner-address">
          <div className="tf-product-side-accordions">
            <div className="widget-accordion wd-product-descriptions">
              <div
                className={`accordion-title ${isOpen ? "active" : "collapsed"}`}
                onClick={toggleAccordion}
                style={{ cursor: "pointer" }}
              >
                <span>Add New Address</span>
                <span
                  className={`icon ${
                    isOpen ? "icon-arrow-up" : "icon-arrow-down"
                  }`}
                />
              </div>
              {isOpen && (
                <div
                  id="address"
                  className={`accordion-body ${isOpen ? "open" : ""}`}
                >
                  <div className="tf-checkout-cart-main accordion-body widget-desc">
                    <form method="post">
                      <div className="item">
                        <div className="box-ip-checkout">
                          <div className="title text-lg fw-medium">
                            Contact Person Details
                          </div>

                          <div className="grid-2 mb_16">
                            <div className="tf-field style-2 style-3">
                              <input
                                className="tf-field-input tf-input only-alphabets"
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                              />
                              <label
                                className="tf-field-label"
                                htmlFor="firstname"
                              >
                                First name
                              </label>
                              {errors.firstName && (
                                <span className="text-danger">
                                  {errors.firstName}
                                </span>
                              )}
                            </div>
                            <div className="tf-field style-2 style-3">
                              <input
                                className="tf-field-input tf-input only-alphabets"
                                type="text"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                              />
                              <label
                                className="tf-field-label"
                                htmlFor="lastname"
                              >
                                Last name
                              </label>
                            </div>
                          </div>

                          <div className="box-ip-shipping">
                            <div className="title text-lg fw-medium">
                              Address Details
                            </div>
                            <div className="grid-3">
                              <fieldset>
                                <label
                                  htmlFor="freeship"
                                  className="check-ship"
                                >
                                  <input
                                    type="radio"
                                    id="freeship"
                                    className="tf-check-rounded"
                                    name="checkshipping"
                                    value="home"
                                    onChange={handleChange}
                                    checked={formData.addressType === "home"}
                                  />
                                  <span className="text text-sm">
                                    <span>Home</span>
                                  </span>
                                </label>
                              </fieldset>

                              <fieldset>
                                <label
                                  htmlFor="officeship"
                                  className="check-ship"
                                >
                                  <input
                                    type="radio"
                                    id="officeship"
                                    className="tf-check-rounded"
                                    name="checkshipping"
                                    value="work"
                                    onChange={handleChange}
                                    checked={formData.addressType === "work"}
                                  />
                                  <span className="text text-sm">
                                    <span>Office</span>
                                  </span>
                                </label>
                              </fieldset>

                              <fieldset>
                                <label
                                  htmlFor="othership"
                                  className="check-ship"
                                >
                                  <input
                                    type="radio"
                                    id="othership"
                                    className="tf-check-rounded"
                                    name="checkshipping"
                                    value="other"
                                    onChange={handleChange}
                                    checked={formData.addressType === "other"}
                                  />
                                  <span className="text text-sm">
                                    <span>Other</span>
                                  </span>
                                </label>
                              </fieldset>
                            </div>
                            {errors.addressType && (
                              <span className="text-danger">
                                {errors.addressType}
                              </span>
                            )}
                          </div>

                          <fieldset className="tf-field style-2 style-3 mb_16">
                            <input
                              className="tf-field-input tf-input"
                              type="text"
                              name="addressLine1"
                              value={formData.addressLine1}
                              onChange={handleChange}
                            />
                            <label className="tf-field-label" htmlFor="address">
                              Address Line 1
                            </label>
                            {errors.addressLine1 && (
                              <span className="text-danger">
                                {errors.addressLine1}
                              </span>
                            )}
                          </fieldset>
                          <fieldset className="tf-field style-2 style-3 mb_16">
                            <input
                              type="text"
                              className="tf-field-input tf-input"
                              name="addressLine2"
                              value={formData.addressLine2}
                              onChange={handleChange}
                            />
                            <label
                              className="tf-field-label"
                              htmlFor="apartment"
                            >
                              Address Line 2 (Optional)
                            </label>
                          </fieldset>

                          <div className="grid-3 mb_16">
                            <fieldset className="tf-field style-2 style-3">
                              <input
                                className="tf-field-input tf-input only-numeric"
                                type="text"
                                maxLength={6}
                                name="pinCode"
                                value={formData.pinCode}
                                onChange={handleChange}
                              />
                              <label className="tf-field-label" htmlFor="code">
                                Pin Code
                              </label>
                              {errors.pinCode && (
                                <span className="text-danger">
                                  {errors.pinCode}
                                </span>
                              )}
                            </fieldset>
                            <fieldset className="tf-field style-2 style-3">
                              <input
                                className="tf-field-input tf-input only-alphabets"
                                type="text"
                                name="district"
                                value={formData.district}
                                onChange={handleChange}
                              />
                              <label className="tf-field-label" htmlFor="city">
                                District
                              </label>
                              {errors.district && (
                                <span className="text-danger">
                                  {errors.district}
                                </span>
                              )}
                            </fieldset>
                            <fieldset className="tf-field style-2 style-3">
                              <input
                                className="tf-field-input tf-input only-alphabets"
                                type="text"
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                              />
                              <label className="tf-field-label" htmlFor="state">
                                State
                              </label>
                              {errors.state && (
                                <span className="text-danger">
                                  {errors.state}
                                </span>
                              )}
                            </fieldset>
                          </div>
                          <fieldset className="tf-field style-2 style-3">
                            <input
                              className="tf-field-input tf-input only-alphabets"
                              type="text"
                              name="country"
                              value={formData.country}
                              onChange={handleChange}
                            />
                            <label className="tf-field-label" htmlFor="country">
                              Country
                            </label>
                            {errors.country && (
                              <span className="text-danger">
                                {errors.country}
                              </span>
                            )}
                          </fieldset>
                        </div>
                      </div>

                      <button
                        className="tf-btn animate-btn"
                        onClick={handleSubmit}
                      >
                        Submit
                      </button>
                    </form>
                  </div>
                </div>
              )}
            </div>
          </div>

          {addresses && (
            <ul className="list-account-address tf-grid-layout md-col-2">
              {addresses.map((address, index) => (
                <li className="account-address-item">
                  <p className="title text-md fw-medium">{address.district}</p>
                  <div className="info-detail">
                    <div className="box-infor">
                      <p className="text-sm">
                        {address.firstName} {address.lastName}
                      </p>
                      <p className="text-sm">
                        {address.addressLine1} {address.addressLine2},{" "}
                        {address.district}, {address.state} - {address.pinCode}{" "}
                        <br /> {address.country}
                      </p>
                    </div>
                    <div className="box-btn">
                      <a
                        href="#"
                        className="text-sm"
                        style={{ textDecoration: "underline" }}
                        onClick={(e) => {
                          deleteAddress(address._id);
                        }}
                      >
                        Delete
                      </a>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </>
  );
}

export default Addresses;
